import { useState } from "react";
import { Note } from "../service/model/note.model";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as noteSlice from "../features/notes/note.slice";
import Loader from "../components/loader";
import useNotes from "../hooks/use-notes";
import NoteTable from "../features/notes/components/note-table";
import NoteForm from "../features/notes/components/note-form";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import { NoteTargetType } from "../shared/enums";
import NoteSummary from "../features/notes/components/note-summary";
import { configs } from "../app/app-configs";

const Notes = () => {
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;
    const [showNoteForm, setShowNoteForm] = useState(false);
    const isLoading = useAppSelector(noteSlice.selectIsLoading);

    const [notes] = useNotes();

    const handlePageChange = (page: number) => {
        dispatch(noteSlice.fetchNotesByBusiness({
            pagination: { page: page - 1, size: configs.PAGE_SIZE },
        }))
    }

    const handleSubmit = (data: Note) => {
        loggedInUser && dispatch(noteSlice.createNote({ ...data })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowNoteForm(false);
            }
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {notes &&
                <>
                    <NoteSummary />
                    {/* <Box sx={{ mb: "12px" }}>
                        <Button variant="contained" className={classes.createButton} onClick={() => setShowNoteForm(true)} style={{ marginBottom: "12px" }}>Add Note</Button>
                    </Box> */}
                    <NoteTable notes={notes} onPageChange={handlePageChange} />
                    {showNoteForm && loggedInUser &&
                        <NoteForm note={undefined} targetType={NoteTargetType.SELF} targetId={loggedInUser.id} editable={true} onClose={() => setShowNoteForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default Notes;